import styled from 'styled-components';
import { colors } from '@alixpartners/ui-components';

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	height: 80vh;
	overflow-y: auto;
	font-size: 16px;
`;

export const DemoPage = styled.div`
	display: flex;
	width: 100%;
`;

export const DemoPageNavigation = styled.div`
	width: 21em;
	padding: 2em 1em;

	@media only screen and (max-width: 750px) {
		display: none;
	}

	nav {
		position: sticky;
		top: 2em;
		background: #fff;
		padding: 0.5em;
		border-radius: 0.75rem;
		box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1),
			0 4px 6px -2px rgba(0, 0, 0, 0.05);

		a {
			display: flex;
			padding: 0.75em 1em;
			text-decoration: none;
			border-radius: 0.25em;
			color: #374151;
			align-items: center;

			button {
				margin: 0;
				height: 20px;

				&:hover {
					background: #f3f4f6;
				}
			}

			&:hover {
				background: #f3f4f6;

				button {
					background: #f3f4f6;
				}
			}

			svg {
				width: 1.25em;
				height: 1.25em;
				margin-right: 1em;
				color: #1f2937;
			}
		}
	}
`;

export const DemoPageContent = styled.div`
	padding: 2em 1em;
	width: 80%;
`;
export const HrefDiv = styled.div`
	position: absolute;
	top: -2em;
`;

export const FormSection = styled.section`
	background: #fff;
	padding: 2em;
	border-radius: 0.75rem;
	line-height: 1.6;
	overflow: hidden;
	margin-bottom: 2rem;
	position: relative;
	font-size: 0.875rem;
	box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1),
		0 4px 6px -2px rgba(0, 0, 0, 0.05);
	h1 {
		font-weight: 500;
		font-size: 1.25rem;
		color: #000;
		margin-bottom: 0.75rem;
	}
	p > {
		margin: 0.5rem 0 1.5rem;
	}
`;

export const NiceFormGroup = styled.div`
	--nf-input-size: 1rem;
	--nf-input-font-size: calc(var(--nf-input-size) * 0.875);
	--nf-small-font-size: calc(var(--nf-input-size) * 0.875);
	--nf-input-font-family: inherit;
	--nf-label-font-family: inherit;
	--nf-input-color: #20242f;
	--nf-input-border-radius: 0.25rem;
	--nf-input-placeholder-color: #929292;
	--nf-input-border-color: #c0c4c9;
	--nf-input-border-width: 1px;
	--nf-input-border-style: solid;
	--nf-input-border-bottom-width: 2px;
	--nf-input-focus-border-color: #3b4ce2;
	--nf-input-background-color: #f9fafb;
	--nf-invalid-input-border-color: var(--nf-input-border-color);
	--nf-invalid-input-background-color: var(--nf-input-background-color);
	--nf-invalid-input-color: var(--nf-input-color);
	--nf-valid-input-border-color: var(--nf-input-border-color);
	--nf-valid-input-background-color: var(--nf-input-background-color);
	--nf-valid-input-color: inherit;
	--nf-invalid-input-border-bottom-color: red;
	--nf-valid-input-border-bottom-color: green;
	--nf-label-font-size: var(--nf-small-font-size);
	--nf-label-color: #374151;
	--nf-label-font-weight: 500;
	--nf-slider-track-background: #dfdfdf;
	--nf-slider-track-height: 0.25rem;
	--nf-slider-thumb-size: calc(var(--nf-slider-track-height) * 4);
	--nf-slider-track-border-radius: var(--nf-slider-track-height);
	--nf-slider-thumb-border-width: 2px;
	--nf-slider-thumb-border-focus-width: 1px;
	--nf-slider-thumb-border-color: #fff;
	--nf-slider-thumb-background: var(--nf-input-focus-border-color);
	display: block;
	margin-top: calc(var(--nf-input-size) * 1.5);
	line-height: 1;
	white-space: nowrap;

	label {
		font-weight: var(--nf-label-font-weight);
		display: block;
		color: var(--nf-label-color);
		font-size: var(--nf-label-font-size);
		font-family: var(--nf-label-font-family);
		margin-bottom: calc(var(--nf-input-size) / 2);
		white-space: normal;
	}

	small {
		font-family: var(--nf-input-font-family);
		display: block;
		font-weight: 400;
		opacity: 0.75;
		font-size: var(--nf-small-font-size);
		margin-bottom: calc(var(--nf-input-size) * 0.75);

		&:last-child {
			margin-bottom: 0;
		}
	}

	legend {
		font-weight: var(--nf-label-font-weight);
		display: block;
		color: var(--nf-label-color);
		font-size: var(--nf-label-font-size);
		font-family: var(--nf-label-font-family);
		margin-bottom: calc(var(--nf-input-size) / 5);
	}

	> input[type='checkbox'],
	> input[type='date'],
	> input[type='email'],
	> input[type='month'],
	> input[type='number'],
	> input[type='password'],
	> input[type='radio'],
	> input[type='search'],
	> input[type='tel'],
	> input[type='text'],
	> input[type='time'],
	> input[type='url'],
	> input[type='week'],
	> select,
	> textarea {
		background: var(--nf-input-background-color);
		font-family: inherit;
		font-size: var(--nf-input-font-size);
		border-bottom-width: var(--nf-input-border-width);
		border-radius: var(--nf-input-border-radius);
		border: var(--nf-input-border-width) var(--nf-input-border-style)
			var(--nf-input-border-color);
		border-bottom: var(--nf-input-border-bottom-width)
			var(--nf-input-border-style) var(--nf-input-border-color);
		color: var(--nf-input-color);
		width: 100%;
		padding: calc(var(--nf-input-size) * 0.75);
		height: calc(var(--nf-input-size) * 2.75);
		line-height: normal;
		appearance: auto;
		transition: all 0.15s ease-out;
	}

	> input[type='month'],
	> textarea {
		width: 350px;
	}

	// Valid and Invalid states
	> input:required:not(:placeholder-shown):invalid {
		background-color: var(--nf-invalid-input-background-color);
		border-bottom-color: var(--nf-valid-input-border-color);
		border-color: var(--nf-valid-input-border-color)
			var(--nf-valid-input-border-color)
			var(--nf-invalid-input-border-bottom-color);
		color: var(--nf-invalid-input-color);
	}
	> select:required:not(:placeholder-shown):invalid {
		background-color: var(--nf-invalid-input-background-color);
		border-bottom-color: var(--nf-valid-input-border-color);
		border-color: var(--nf-valid-input-border-color)
			var(--nf-valid-input-border-color)
			var(--nf-invalid-input-border-bottom-color);
		color: var(--nf-invalid-input-color);
	}

	> input:required:not(:placeholder-shown):valid {
		background-color: var(--nf-valid-input-background-color);
		border-bottom-color: var(--nf-valid-input-border-color);
		border-color: var(--nf-valid-input-border-color)
			var(--nf-valid-input-border-color)
			var(--nf-valid-input-border-bottom-color);
		color: var(--nf-valid-input-color);
	}
	> select:required:not(:placeholder-shown):valid {
		background-color: var(--nf-valid-input-background-color);
		border-bottom-color: var(--nf-valid-input-border-color);
		border-color: var(--nf-valid-input-border-color)
			var(--nf-valid-input-border-color)
			var(--nf-valid-input-border-bottom-color);
		color: var(--nf-valid-input-color);
	}

	// Focus state
	> input:focus {
		outline: none;
		border-color: var(--nf-input-focus-border-color);
	}
	> select:focus {
		outline: none;
		border-color: var(--nf-input-focus-border-color);
	}
`;

export const NiceFormFieldSet = styled.fieldset`
	padding: 0;
	font-size: 100%;
	font: inherit;
	vertical-align: initial;
	--nf-input-size: 1rem;
	--nf-input-font-size: calc(var(--nf-input-size) * 0.875);
	--nf-small-font-size: calc(var(--nf-input-size) * 0.875);
	--nf-input-font-family: inherit;
	--nf-label-font-family: inherit;
	--nf-input-color: #20242f;
	--nf-input-border-radius: 0.25rem;
	--nf-input-placeholder-color: #929292;
	--nf-input-border-color: #c0c4c9;
	--nf-input-border-width: 1px;
	--nf-input-border-style: solid;
	--nf-input-border-bottom-width: 2px;
	--nf-input-focus-border-color: #3b4ce2;
	--nf-input-background-color: #f9fafb;
	--nf-invalid-input-border-color: var(--nf-input-border-color);
	--nf-invalid-input-background-color: var(--nf-input-background-color);
	--nf-invalid-input-color: var(--nf-input-color);
	--nf-valid-input-border-color: var(--nf-input-border-color);
	--nf-valid-input-background-color: var(--nf-input-background-color);
	--nf-valid-input-color: inherit;
	--nf-invalid-input-border-bottom-color: red;
	--nf-valid-input-border-bottom-color: green;
	--nf-label-font-size: var(--nf-small-font-size);
	--nf-label-color: #374151;
	--nf-label-font-weight: 500;
	--nf-slider-track-background: #dfdfdf;
	--nf-slider-track-height: 0.25rem;
	--nf-slider-thumb-size: calc(var(--nf-slider-track-height) * 4);
	--nf-slider-track-border-radius: var(--nf-slider-track-height);
	--nf-slider-thumb-border-width: 2px;
	--nf-slider-thumb-border-focus-width: 1px;
	--nf-slider-thumb-border-color: #fff;
	--nf-slider-thumb-background: var(--nf-input-focus-border-color);
	margin-top: calc(var(--nf-input-size) * 1.5);

	legend {
		font-weight: var(--nf-label-font-weight);
		display: block;
		color: var(--nf-label-color);
		font-size: var(--nf-label-font-size);
		font-family: var(--nf-label-font-family);
		margin-bottom: calc(var(--nf-input-size) / 5);
	}
	div {
		display: flex;
		white-space: nowrap;

		label {
			font-weight: 400;
			display: block;
			color: var(--nf-label-color);
			font-size: var(--nf-label-font-size);
			font-family: var(--nf-label-font-family);
			white-space: normal;
		}
		input {
			box-sizing: border-box;
			padding: 0;
			margin: 5px;
		}
		small {
			font-family: var(--nf-input-font-family);
			display: block;
			font-weight: 400;
			opacity: 0.75;
			font-size: var(--nf-small-font-size);
			margin-bottom: calc(var(--nf-input-size) * 0.75);

			&:last-child {
				margin-bottom: 0;
			}
		}

		// Valid and Invalid states
		> input:required:not(:placeholder-shown):invalid {
			background-color: var(--nf-invalid-input-background-color);
			border-bottom-color: var(--nf-valid-input-border-color);
			border-color: var(--nf-valid-input-border-color)
				var(--nf-valid-input-border-color)
				var(--nf-invalid-input-border-bottom-color);
			color: var(--nf-invalid-input-color);
		}

		> input:required:not(:placeholder-shown):valid {
			background-color: var(--nf-valid-input-background-color);
			border-bottom-color: var(--nf-valid-input-border-color);
			border-color: var(--nf-valid-input-border-color)
				var(--nf-valid-input-border-color)
				var(--nf-valid-input-border-bottom-color);
			color: var(--nf-valid-input-color);
		}

		// Focus state
		> input:focus {
			outline: none;
			border-color: var(--nf-input-focus-border-color);
		}
	}
`;

export const RangeWrapper = styled.div`
	display: flex;
	align-items: center;
	width: 50%;
	padding: 0 16px;

	.rc-slider {
		.rc-slider-track {
			background-color: ${colors.green1};
		}

		.rc-slider-handle {
			background-color: ${colors.green1};
			border-color: ${colors.green1};
			opacity: 1;
			width: 16px;
			height: 16px;
			margin-top: -6px;

			&:focus {
				box-shadow: 0 0 0 3px rgb(92, 179, 53, 0.4);
				border-color: ${colors.green1};
			}

			&.rc-slider-handle-dragging {
				box-shadow: 0 0 0 6px rgb(92, 179, 53, 0.4);
			}
		}
	}
`;

export const InputWrapper = styled.div`
	width: 90px;
	min-width: 90px;

	input {
		min-width: 90px;
	}
	.checkbox-input input {
		height: 31px;
	}
`;

export const RangeInputWrapper = styled.div`
	max-width: 500px;
	display: flex;
	align-items: center;
	width: 100%;
`;

export const BoldText = styled.span`
	font-weight: bold;
`;

export const UnderlinedText = styled.span`
	text-decoration: underline;
`;
